import { useEffect } from "react"

import { type TUserState, useUser } from "@/3514/hooks/use-user"
import { isUserParticipant, setDatadogUser, setSentryUser } from "@/3514/utils"

function useLoggingUserSet(): void {
    const { isLoaded, user }: TUserState = useUser()

    useEffect((): void => {
        if (isLoaded) {
            const extraData: object = isUserParticipant(user)
                ? { cohort: user.cohortName, organization: user.organizationName }
                : {}

            setSentryUser(user, extraData)

            setDatadogUser(user, extraData)
        }
    }, [user, isLoaded])
}

export { useLoggingUserSet }
